<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
    v-html="path" />
</template>

<script setup>
import { computed } from 'vue'

// Shared editor icon set (heroicon-flavored) so the editor uses consistent
// SVGs instead of mixed Unicode glyphs (⋮⋮ ▾ ✕ ▭ ▯ ▲ ▼ ✨ 🔗 …).
const PATHS = {
  'chevron-down': '<polyline points="6 9 12 15 18 9" />',
  'chevron-right': '<polyline points="9 6 15 12 9 18" />',
  'arrow-up': '<line x1="12" y1="19" x2="12" y2="5" /><polyline points="6 11 12 5 18 11" />',
  'arrow-down': '<line x1="12" y1="5" x2="12" y2="19" /><polyline points="6 13 12 19 18 13" />',
  drag: '<circle cx="9" cy="6" r="1" /><circle cx="9" cy="12" r="1" /><circle cx="9" cy="18" r="1" /><circle cx="15" cy="6" r="1" /><circle cx="15" cy="12" r="1" /><circle cx="15" cy="18" r="1" />',
  desktop: '<rect x="2" y="4" width="20" height="13" rx="2" /><path d="M8 21h8M12 17v4" />',
  tablet: '<rect x="5" y="3" width="14" height="18" rx="2" /><line x1="12" y1="17" x2="12" y2="17" />',
  mobile: '<rect x="7" y="3" width="10" height="18" rx="2" /><line x1="12" y1="18" x2="12" y2="18" />',
  undo: '<path d="M9 14 4 9l5-5" /><path d="M4 9h11a5 5 0 0 1 0 10h-1" />',
  redo: '<path d="m15 14 5-5-5-5" /><path d="M20 9H9a5 5 0 0 0 0 10h1" />',
  sidebar: '<rect x="3" y="4" width="18" height="16" rx="2" /><line x1="9" y1="4" x2="9" y2="20" />',
  preview: '<rect x="3" y="4" width="18" height="14" rx="2" /><path d="M8 21h8" />',
  sparkles: '<path d="M12 3l1.6 4.6L18 9l-4.4 1.4L12 15l-1.6-4.6L6 9l4.4-1.4z" /><path d="M19 14l.7 2 .3 .7-2-.7-2 .7 .7-2 .3-.7z" />',
  close: '<line x1="6" y1="6" x2="18" y2="18" /><line x1="18" y1="6" x2="6" y2="18" />',
  link: '<path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1.5 1.5" /><path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1.5-1.5" />',
  'link-off': '<path d="M9 17H7a5 5 0 0 1 0-10h2M15 7h2a5 5 0 0 1 4 8M8 12h4M2 2l20 20" />',
  type: '<polyline points="4 7 4 4 20 4 20 7" /><line x1="9" y1="20" x2="15" y2="20" /><line x1="12" y1="4" x2="12" y2="20" />',
  'clear-format': '<polyline points="4 7 4 4 20 4 20 7" /><line x1="9" y1="20" x2="15" y2="20" /><line x1="12" y1="4" x2="12" y2="20" /><line x1="3" y1="3" x2="21" y2="21" />',
  search: '<circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.65" y2="16.65" />',
  duplicate: '<rect x="9" y="9" width="11" height="11" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />',
  history: '<path d="M12 8v4l3 1.5" /><path d="M3.05 11a9 9 0 1 1 .5 4" /><polyline points="3 21 3 15 9 15" />',
  trash: '<polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /><line x1="10" y1="11" x2="10" y2="17" /><line x1="14" y1="11" x2="14" y2="17" />',
  plus: '<line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />'
}

const props = defineProps({ name: { type: String, required: true } })
const path = computed(() => PATHS[props.name] || '')
</script>
